const getTranslateProps = (filter, propName) => {
    if (filter === 'year') {
        return propName;
    }

    const data = {
        genre: {
            action: 'боевик',
            adventure: 'приключения',
            biography: 'биография',
            comedy: 'комедия',
            crime: 'криминал',
            detective: 'детектив',
            drama: 'драма',
            family: 'семейный',
            fantastic: 'фантастика',
            fantasy: 'фэнтези',
            historical: 'исторический',
			horror: 'ужасы',
            melodrama: 'мелодрама',
            military: 'военный',
            music: 'музыка',
            musical: 'мюзикл',
            sport: 'спорт',
            thriller: 'триллер',
            western: 'вестерн',
        },
        country: {
            Britain: 'Великобритания',
            Canada: 'Канада',
            China: 'Китай',
			Colombia: 'Колумбия',
            Czechoslovakia: 'Чехословакия',
            Denmark: 'Дания',
            France: 'Франция',
            Germany: 'Германия',
            'Hong-Kong': 'Гонконг',
			Japan: 'Япония',
            Luxembourg: 'Люксембург',
            Poland: 'Польша',
            Russia: 'Россия',
			'South-Africa': 'ЮАР',
            Spain: 'Испания',
            Sweden: 'Швеция',
            USA: 'США',
            USSR: 'СССР',
        },
        type: {
            film: 'фильм',
            series: 'сериал',
            cartoon: 'мультфильм',
            premieres: 'премьер'
        },
    };

    return data[filter][propName];
};

export default getTranslateProps;